import React from 'react';

const NotFound = () => {
      return (
            <div>
                  <h1>Sorry, the page are not found</h1>
                  <h4>404 Erorr!!!</h4>
            </div>
      );
};

export default NotFound;